import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat, Span } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const VocationalMaturityFirstPage = ({ user, background, number }) => {
  // const confictosInternos = parseFloat(user['Conflictos internos']);
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>3.5. Dificultades de información</h2>
          <p className='justified'>
            Las dificultades de información se relacionan con el{' '}
            <strong>
              nivel de conflicto (externo e interno) asociado a la toma de
              decisión de carrera, así como a la calidad y cantidad de
              información disponible
            </strong>{' '}
            sobre ti mismo (Self), las ocupaciones o carreras, y el proceso de
            toma de decisión.
          </p>
          <p className='justified'>
            Resultados en
            <Span strong color={polarColors[0]}>
              {' '}
              ROJO{' '}
            </Span>
            sugieren un alto nivel de conflicto o falta de información. <br />
            Resultados en{' '}
            <Span strong color={polarColors[4]}>
              VERDE
            </Span>{' '}
            sugieren un bajo nivel de conflicto o falta de información.
          </p>
          <p className='justified'>
            Recuerda pensar estos colores como una guía tal como si fuera un
            semáforo. El color rojo indica que debes detenerte a revisar tus
            ideas e información sobre el proceso, y color verde indica que tus
            creencias están alineadas y no serán un obstáculo para tu proceso de
            toma de decisión.
          </p>
          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationalMaturityFirstPage;
